import React from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';

const momentFieldNames = ['maxDate', 'minDate', 'value', 'startDateValue', 'endDateValue'];
const momentActionNames = ['handleChangeStart', 'handleChangeEnd', 'onBlur', 'onChange'];

const withMomentAdapter = (WrappedComponent) => {
  const MomentAdapter = React.memo((props) => {
    MomentAdapter.displayName = `MomentAdapterFor(${getDisplayName(WrappedComponent)})`;

    const nativeDateValues = {};
    const nativeDateActions = {};

    momentFieldNames.forEach((field) => {
      if (!props[field]) {
        return (nativeDateValues[field] = props[field]);
      }
      if (moment.isMoment(props[field])) {
        return (nativeDateValues[field] = props[field].toDate());
      }
      return (nativeDateValues[field] = moment(props[field]).toDate());
    });

    momentActionNames.forEach((field) => {
      if (props[field] && moment.isMoment(props[field])) {
        return (nativeDateValues[field] = props[field].toDate());
      }
      nativeDateValues[field] = (e) => {
        if (props[field]) {
          const value = e ? moment(e) : e;
          props[field](value);
        }
      };
    });

    return <WrappedComponent {...props} {...nativeDateActions} {...nativeDateValues} />;
  });
  MomentAdapter.propTypes = {
    input: PropTypes.object,
    meta: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  };
  return MomentAdapter;
};

export default withMomentAdapter;

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
